<template>
  <div class="wrapper-page-layout">
    <div class="container page-layout">
      <header class="mt-4 pl-0 ml-0">
        <slot name="header"></slot>
      </header>
      <main>
        <slot name="main"></slot>
      </main>
    </div>
    <div v-if="canUseFilters" class="filter-wrapper" @click="toggleFilter()">
      <div class="toggle-wrapper">
        <button aria-hidden="true" class="toggle-menu">
          <i class="material-icons clickable filter-icon" v-show="!showFilter">
            arrow_left
          </i>
          <i class="material-icons clickable filter-icon" v-show="showFilter">
            arrow_right
          </i>
        </button>
        <div v-if="!showFilter">
          <slot name="filter-collapsed"></slot>
        </div>
      </div>
      <b-collapse class="filter-collapse" :visible="showFilter">
        <slot name="filter"></slot>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isAdmin, isBasicPlan } from '@/service/user'

export default {
  computed: {
    ...mapGetters({
      showFilter: 'user/showFilter',
    }),
    canUseFilters() {
      return isAdmin() && !isBasicPlan()
    },
  },
  methods: {
    toggleFilter() {
      this.$store.dispatch('user/updateShowFilter', !this.showFilter)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.wrapper-page-layout {
  display: flex;
  flex-direction: row;

  .filter-wrapper {
    display: flex;
    flex-direction: column;
    padding: 0;
    transition: all ease-in-out 0.1s;

    background-color: map-get($theme-colors, 'white');
    border-left: 1px solid map-get($theme-colors, 'gray07');

    .btn {
      width: 100%;
    }

    .filter-collapse {
      height: 100%;
      min-width: 10px;
    }

    .toggle-wrapper {
      position: relative;

      .toggle-menu {
        background-color: map-get($theme-colors, 'gray06');
        border: none;
        border-radius: 25px;
        color: map-get($theme-colors, 'primary');
        height: 18px !important;
        padding: 0;
        position: absolute;
        left: -10px;
        top: 16px;
        width: 18px;

        &:hover {
          box-shadow: 0 5px 18px 0 rgba(0, 0, 0, 0.2);
        }
      }
    }
  }

  .page-layout {
    padding-left: 40px;
    padding-right: 35px;
    display: flex;
    flex-direction: column;
    max-width: 1200px;
  }

  /* Mediun Devices ( 991.98px ) */
  @media (max-width: 991.98px) {
    header {
      padding-top: 0px;
      padding-bottom: 0px;
      margin-top: 0px !important;
      margin-bottom: 0px !important;
    }
    .page-layout {
      padding-left: 0px;
      padding-right: 0px;

      .nav-item a {
        margin-bottom: 0px !important;
        margin-top: 0px !important;
      }

      .header.nav {
        padding-left: 10px;
        padding-right: 0px;
      }
    }
  }
}
</style>
